
export default function TrustSignals() {
  return (
    <section className="bg-[#f8f9fa] py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full shadow-lg flex items-center justify-center">
              <i className="ri-time-line text-[#1a2332] text-4xl"></i>
            </div>
            <div className="text-5xl font-black text-[#1a2332] mb-2">15+</div>
            <p className="text-lg text-gray-700 font-medium">Años de Experiencia<br />en Barcelona</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full shadow-lg flex items-center justify-center">
              <i className="ri-car-line text-[#1a2332] text-4xl"></i>
            </div>
            <div className="text-5xl font-black text-[#1a2332] mb-2">15.000+</div>
            <p className="text-lg text-gray-700 font-medium">Coches Comprados<br />y Gestionados</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 bg-white rounded-full shadow-lg flex items-center justify-center">
              <i className="ri-flashlight-line text-[#1a2332] text-4xl"></i>
            </div>
            <div className="text-5xl font-black text-[#1a2332] mb-2">24h</div>
            <p className="text-lg text-gray-700 font-medium">Tasación y Respuesta<br />Garantizada</p>
          </div>
        </div>
      </div>
    </section>
  );
}
